import { load } from '../../../Utils/localStorage';
import { createReducer } from '@reduxjs/toolkit';

import {
  setUserData,
  setAuthState,
  userLogout,
} from '../../Actions/UserActions';

const usr = load('User');

export const defaultUserState = {
  name: null,
  email: null,
  role: null,
  avatarURL: null,
  tokenAccess: null,
  tokenRefresh: null,
};

const userState = usr ? { ...JSON.parse(usr), Auth: true } : defaultUserState;

const user = createReducer(userState, {
  [setAuthState]: (state, action) => {
    state.Auth = action.payload;
  },
  [setUserData]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [userLogout]: (state, action) => {
    return { ...action.payload };
  },
});

export default user;
